import { atom, RecoilState } from 'recoil';

export enum Permission {
  READ_PROJECT = '1',
  WRITE_PROJECT = '2',
  READ_ALL_SUBPROJECT = '3',
  WRITE_ALL_SUBPROJECT = '4',
  READ_SUBPROJECT = '5',
  WRITE_SUBPROJECT = '6',
  READ_ALL_USER = '8',
  WRITE_ALL_USER = '9',
  READ_USER = '10',
  WRITE_USER = '11',
  READ_ALL_PATIENT = '12',
  WRITE_ALL_PATIENT = '13',
  READ_PATIENT = '14',
  WRITE_PATIENT = '15',
  READ_VISIT_TEMPLATE = '18',
  WRITE_VISIT_TEMPLATE = '19',
  READ_VISIT = '20',
  WRITE_VISIT = '21',
  READ_FORM_TEMPLATE = '22',
  WRITE_FORM_TEMPLATE = '23',
  READ_FORM = '24',
  WRITE_FORM = '25',
  READ_PERSONAL_INFO = '100',
  SUPERADMIN = '9999',
}

export type PermissionArray = Array<Permission>;

export const permissionState: RecoilState<PermissionArray> =
  atom<PermissionArray>({
    key: 'permissionState',
    default: [],
  });
